{
  "id": "sunflower",
  "name": "Sunflower",
  "species": "Helianthus annuus",
  "ploidy": 2,
  "assembly": "HanXRQr2.0-SUNRISE (NCBI GCF_002127325.2; HanXRQChr01-HanXRQChr17) and HA412-HOv2.0 (Ha412HOChr01-Ha412HOChr17), which share the LG1-LG17 numbering of the sunflower consensus genetic map",
  "chromosomes": [
    "1",
    "2",
    "3",
    "4",
    "5",
    "6",
    "7",
    "8",
    "9",
    "10",
    "11",
    "12",
    "13",
    "14",
    "15",
    "16",
    "17"
  ],
  "keys": [
    "1",
    "2",
    "3",
    "4",
    "5",
    "6",
    "7",
    "8",
    "9",
    "10",
    "11",
    "12",
    "13",
    "14",
    "15",
    "16",
    "17"
  ],
  "pattern": "^(?:ha412hochr|hanxrqchr|chr|chromosome)?[_\\s-]?0*([1-9]|1[0-7])$",
  "sources": [
    "https://ftp.ncbi.nlm.nih.gov/genomes/all/GCF/002/127/325/GCF_002127325.2_HanXRQr2.0-SUNRISE/GCF_002127325.2_HanXRQr2.0-SUNRISE_assembly_report.txt",
    "https://www.ncbi.nlm.nih.gov/nuccore/CM007890.1",
    "https://static-content.springer.com/esm/art%3A10.1038%2Fnature22380/MediaObjects/41586_2017_BFnature22380_MOESM1_ESM.pdf",
    "https://www.ebi.ac.uk/europepmc/webservices/rest/PMC3385978/fullTextXML",
    "https://www.ebi.ac.uk/europepmc/webservices/rest/PMC10083583/supplementaryFiles",
    "https://sunflowergenome.org/assembly-data/"
  ]
}
